// 用户类型定义
export var userTypeMap = {
    // 员工
    staff: "小二",
    // CP
    cp: "CP",
    // 快递员
    courier: "快递员",
    // 消费者
    consumer: "消费者",
    // 商家
    merchant: "商家",
    // BD
    bd: "BD",
    unknown: "未知"
};
/**
 * 账号类型定义
 */ export var accountTypeMap = {
    // buc
    BUC: "BUC",
    // mozi
    MOZI: "MOZI",
    // cbc 菜鸟会员-内部小二
    CBC: "CBC",
    // cic 菜鸟会员-外部客户、消费者
    CIC: "CIC",
    // 淘宝账号
    UIC: "UIC",
    // 4px自建登录体系
    FOUR_PX: "4PX",
    // 申通
    STO: "STO",
    // 其他未知的
    UNKNOWN: "unknown"
};

 //# sourceMappingURL=constant.js.map